import {
  Children,
  cloneElement,
  isValidElement,
  type ComponentProps,
  type FC,
  type PropsWithChildren,
  type ReactElement,
} from 'react';

import { detailListClass } from '@eneco/custom-components/flows/DetailListItem.css';
import { Box, Card, Stack } from '@eneco/sparky';

import { type DetailListItemProps } from './DetailListItem';

export interface DetailListProps {
  /** Card corner style. Defaults to `rounded`. Supports responsive values. */
  corners?: ComponentProps<typeof Card>['corners'];
  /** Render a divider under each item's text column. Defaults to `true`. */
  withDividers?: boolean;
}

/** Card list container for {@link DetailListItem} rows with optional dividers. */
export const DetailList: FC<PropsWithChildren<DetailListProps>> = ({
  children,
  corners = 'rounded',
  withDividers = true,
}) => {
  const items = Children.toArray(children).filter(Boolean);
  const lastIndex = items.length - 1;

  return (
    <Box className={detailListClass}>
      <Card corners={corners} elevation="S" overflow="hidden">
        <Stack as="ul">
          {items.map((child, index) => {
            if (!isValidElement(child)) {
              return child;
            }

            return cloneElement(child as ReactElement<DetailListItemProps>, {
              withDivider: withDividers && index < lastIndex,
            });
          })}
        </Stack>
      </Card>
    </Box>
  );
};
